import React from 'react';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ShipmentInfoReturnDetailListTemplate = ({ store, store: { tableData, data, noDataItem, change, loading } }) => {
	if (loading) return null;
	return (
		<React.Fragment>
			<BaasicTable
				{...{
					tableData,
					store,
					noDataItem,
					change,
				}}
				data={data.slice()}
			/>
		</React.Fragment>
	);
};
export default defaultTemplate(ShipmentInfoReturnDetailListTemplate);
